"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.queryStatuses = void 0;
exports.queryStatuses = ['error', 'success', 'idle', 'loading'];
